import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { mapDispatchToProps as sourceMapDispatchToProps } from 'Component/Product/Product.container';
import {
    ACTIONS_SCROLL_BOTTOM_TRESHOLD,
    ACTIONS_SCROLL_DEBOUNCE_DELAY,
    STICKY_ACTIONS_OFFSET,
} from 'Component/ProductActions/ProductActions.config';
import {
    mapStateToProps,
    ProductActionsContainer as SourceProductActionsContainer,
} from 'SourceComponent/ProductActions/ProductActions.container';
import { debounce } from 'Util/Request';

export const ProductDispatcher = import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    'Store/Product/Product.dispatcher'
);

export { mapStateToProps };

/** @namespace Advox/Component/ProductActions/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch),
    requestProduct: (options) => {
        ProductDispatcher.then(({ default: dispatcher }) => dispatcher.handleData(dispatch, options));
    },
});

/** @namespace Advox/Component/ProductActions/Container */
export class ProductActionsContainer extends SourceProductActionsContainer {
    static propTypes = {
        ...SourceProductActionsContainer.propTypes,
        showAlternativeDesign: PropTypes.bool.isRequired,
    };

    state = {
        ...this.state,
        showFixedAddToCart: false,
    };

    containerFunctions = {
        ...this.containerFunctions,
        reloadProduct: this.reloadProduct.bind(this),
        calculateStyles: this.calculateStyles.bind(this),
    };

    componentDidMount() {
        this.debouncedActionsScroll = debounce(this.checkInViewPort.bind(this), ACTIONS_SCROLL_DEBOUNCE_DELAY);

        window.addEventListener('scroll', this.debouncedActionsScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.debouncedActionsScroll);
    }

    containerProps() {
        const { showFixedAddToCart } = this.state;
        const { showAlternativeDesign } = this.props;

        return {
            ...super.containerProps(),
            showFixedAddToCart,
            showAlternativeDesign,
        };
    }

    checkInViewPort() {
        const element = document.getElementById('ProductActionsAddToCartWrapper');

        if (element) {
            const { bottom } = element.getBoundingClientRect();

            this.setState({
                showFixedAddToCart: bottom < ACTIONS_SCROLL_BOTTOM_TRESHOLD,
            });
        }
    }

    calculateStyles(style, distanceFromTop, isSticky) {
        const parentContainer = document.getElementById('ProductActions-Main');
        let noStickStyles = {};
        let stickStyles = {};

        if (parentContainer) {
            const { width, left } = parentContainer.getBoundingClientRect();

            if (distanceFromTop < STICKY_ACTIONS_OFFSET && distanceFromTop > 0 && !isSticky) {
                noStickStyles = {
                    position: 'fixed',
                    top: '0',
                    paddingTop: `${STICKY_ACTIONS_OFFSET}px`,
                    width,
                    left,
                };
            }

            if (isSticky) {
                stickStyles = {
                    paddingTop: `${STICKY_ACTIONS_OFFSET}px`,
                };
            }
        }

        return { ...noStickStyles, ...stickStyles };
    }

    reloadProduct(qty) {
        const {
            requestProduct,
            product: { id },
        } = this.props;

        requestProduct({
            isSingleProduct: true,
            args: { filter: { productID: id } },
            qty,
        });
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductActionsContainer);
